export default __webpack_public_path__ + "static/dropdown-menu.light-c2a22e3a4d5d2897e38566a241faf907090f418ba7cb1aeb3416c61dca903be2.png";